import { Core } from '../core/Core';
import { IncomingFlutterMessageType } from '../data/BridgeData';
import { FlutterBridgeService } from './FlutterBridgeService';

export class UIService {
	core: Core;
	cycleDemoModeBoxing: any;

	constructor(core: Core) {
		this.core = core;
		this.setupButtons();
	}

	setupButtons() {
		const button1 = document.createElement('button');
		const button2 = document.createElement('button');

		button1.classList.add('button');
		button1.classList.add('button1');
		button1.addEventListener('click', () => this.setExercise(1));
		button1.textContent = "Exercise 1";

		button2.classList.add('button');
		button2.classList.add('button2');
		button2.addEventListener('click', () => this.setExercise(2));
		button2.textContent = "Exercise 2";

		document.body.appendChild(button1);
		document.body.appendChild(button2);
	}

	setExercise(number: number) {
		const sFlutterBridge: FlutterBridgeService = this.core.s('FlutterBridge');
		sFlutterBridge.receiveFlutterMessage({ event_type: IncomingFlutterMessageType.soft_idle, payload: null });

		if (number == 1) {
			sFlutterBridge.receiveFlutterMessage({
				event_type: IncomingFlutterMessageType.set_camera, payload: {
					camera_angle: Math.random() > 0.5 && 'topLeft' || 'topRight'
				}
			});
			sFlutterBridge.receiveFlutterMessage({
				event_type: IncomingFlutterMessageType.play_animation, payload: {
					exercise_variant_id: "Leaning Balance",
				}
			});
		} else {
			sFlutterBridge.receiveFlutterMessage({
				event_type: IncomingFlutterMessageType.set_camera, payload: {
					camera_angle: Math.random() > 0.5 && 'frontLeft' || 'frontRight'
				}
			});
			sFlutterBridge.receiveFlutterMessage({
				event_type: IncomingFlutterMessageType.play_animation, payload: {
					exercise_variant_id: "Cardio Bloxing",
				}
			});
		}
	}
}
